import UserPreferences from '@/Client/Model/UserPreferences';

export default {
  computed: {
    companyLogin() {
      return UserPreferences.getCompanyLogin();
    },
    companyCssClass() {
      return this.hasCompanyLogin ? this.companyLogin.cssClass ?? '' : '';
    },
    hasCompanyLogin() {
      return null !== this.companyLogin;
    },
  },
}
